import * as React from 'react';
import * as Cookies from 'js-cookie';

import {UserContext} from 'src/components/Firebase';
import {IUser} from '../../model/User';
import Constants from '../../constants';

class HeaderUser extends React.Component<{}, {}> {

  constructor(props: {}) {
    super(props);
  }

  public render() {

    return(
      <span>
        <UserContext.Consumer>
          { (user: IUser) => {
            if (!user.secureData) {
              return;
            }
            const username = user.secureData.email.split('@')[0];
            Cookies.set(Constants.username, username);
            return(
              <span>
                Karma: {user.secureData.rating} •  {username}
              </span>
            )}
          }
        </UserContext.Consumer>

      </span>
    )
  }
}

export default HeaderUser;